import { useReducer } from "react";

import { ICorporateBuyPlansFormStateType } from "../types";

const buyFormStateInitializer = (
  initialArg: ICorporateBuyPlansFormStateType,
) => {
  return initialArg;
};

export default function useBuyFormState(
  initialValue: ICorporateBuyPlansFormStateType,
) {
  return useReducer(
    (
      state: ICorporateBuyPlansFormStateType,
      partialState: Partial<ICorporateBuyPlansFormStateType>,
    ) => {
      return {
        ...state,
        ...partialState,
      };
    },
    initialValue,
    buyFormStateInitializer,
  );
}
